import { render, staticRenderFns } from "./SubscriptionRequests.vue?vue&type=template&id=31388819&"
import script from "./SubscriptionRequests.vue?vue&type=script&lang=js&"
export * from "./SubscriptionRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports